export const PROJECT_NAMES: string[] = [
  "Custom Home - Oak Ridge",
  "Kitchen Remodel - Pine St.",
  "Office Buildout - Downtown",
  "Roof Replacement - Lakeside",
  "ADU Construction - Maple Ave.",
];

export const CONFIRMATION_MESSAGES = {
  unsavedChanges:
    "Are you sure you want to exit before saving? Your changes will be lost.",
};

export const PAGE_SIZE = 5;


